"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const style_1 = require("./style");
function ScrollingLoader() {
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(style_1.Dot, null, ""),
        react_1.default.createElement(style_1.Dot, null, ""),
        react_1.default.createElement(style_1.Dot, null, "")));
}
exports.default = ScrollingLoader;
